<template>
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="false"></Topo>
    <Migalha label="Área Restrita"></Migalha>
    <v-flex xs12 p-t-20 v-show="erros.erro">
      <v-alert :value="erros.erro" type="error" outline>
        <div  v-html="erros.msg"></div>
      </v-alert>
    </v-flex>
  
    <div class="abasCadastro">
      <v-tabs v-model="activeTab" slider-color="ss" class="abasStyle">
        <v-flex xs12>          
          <v-tab
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-dados','abaErro':erros.abaErro=='tab-dados'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-dados')"
          >
            Dados
            <br>Do
            <strong>Fornecedor</strong>
          </v-tab>
          <v-tab
            v-if="model.tipFornecedor != 'F'"
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-hab-juridica','abaErro':erros.abaErro=='tab-hab-juridica'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-hab-juridica')"
          >
            Habilitação
            <br>
            <strong>Jurídica</strong>
          </v-tab>
          <v-tab
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-familia','abaErro':erros.abaErro=='tab-familia'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-familia')"
          >
            <strong>Família</strong>
          </v-tab>
          <v-tab
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-qualificacaoTecnica','abaErro':erros.abaErro=='tab-qualificacaoTecnica'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-qualificacaoTecnica')"
          >
            <strong>Qualificação</strong>
            <br>Técnica
          </v-tab>

          <v-tab
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-regularidadeFiscal','abaErro':erros.abaErro=='tab-regularidadeFiscal'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-regularidadeFiscal')"
          >
            <strong>Regularidade</strong> Fiscal
            <br>e Trabalhista
          </v-tab>
          <v-tab
            v-if="model.tipoCertificado === 1"
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-qualificacao','abaErro':erros.abaErro=='tab-qualificacao'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-qualificacao')"
          >
            <strong>Qualificação</strong>
            <br>econômico-financeira
          </v-tab>
          <v-tab
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-formulariosDeclaracoes','abaErro':erros.abaErro=='tab-formulariosDeclaracoes'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-formulariosDeclaracoes')"
          >
            Formulários
            <br>e
            <strong>Declarações</strong>
          </v-tab>
        </v-flex>
        <v-tab-item value="tab-dados" >
          <v-form v-model="valid" ref="dadosBasicosForm">
            <dadosBasicos
              :model="model"
              :OldModel="OldModel"
              :upload="upload"
              :listaDocFornecSolicitacao="listaDocFornecSolicitacao"
              v-on:observacaoAbrir="fnAcaoModalRejeitar().abrir($event)"
              v-on:aprovarCampo="fnAcaoModalRejeitar().aprovarCampo($event)"
              v-on:notificar_crc="imprimir_crc($event)"
            ></dadosBasicos>
          </v-form>
        </v-tab-item>
        <v-tab-item value="tab-hab-juridica">
          <v-form
            v-model="valid"
            v-show="activeTab=='tab-hab-juridica'"
            ref="habilitacaoJuridicaForm"
          >
            <habilitacaoJuridica
              v-on:observacaoAbrir="fnAcaoModalRejeitar().abrir($event)"
              v-on:aprovarCampo="fnAcaoModalRejeitar().aprovarCampo($event)"
              :erroHabilitacaoJuridica="erros"
              :model="model"
              :OldModel="OldModel"
              :isAlteracao="isAlteracaoComputed"
              :acaoTela="acaoTelaComputed"
              :upload="upload"
              :listaDocFornecSolicitacao="listaDocFornecSolicitacao"
              :hasErroDocHabilitacao="hasErroDocHabilitacao"
            ></habilitacaoJuridica>
          </v-form>
        </v-tab-item>
        <v-tab-item value="tab-familia">
          <v-form v-model="valid" ref="familia">
            <familia 
              :model="model" 
              :OldModel="OldModel"
              :isAlteracao="isAlteracaoComputed"
              :acaoTela="acaoTelaComputed" 
              :erroFamilia="erros"
              :listaDocsQualificacaoTecnica="listaDocsQualificacaoTecnica"
              :getListaDocsQualificacaoTecnica="getListaDocsQualificacaoTecnica"
            ></familia>
          </v-form>
        </v-tab-item>
        <v-tab-item value="tab-qualificacaoTecnica">
          <v-form
            v-model="valid"
            ref="qualificacaoTecnica"
            v-if="activeTab=='tab-qualificacaoTecnica'"
          >
            <qualificacaoTecnica
              :model="model"
              :OldModel="OldModel"
              :listaDocsQualificacaoTecnica="listaDocsQualificacaoTecnica"
              :erroQualificacaoTecnica="erros"
              :fornecedorQualificacaoTecnicaVm="fornecedorQualificacaoTecnicaVm"
              :cadastroFornecedor="cadastroFornecedor"
            ></qualificacaoTecnica>
          </v-form>
        </v-tab-item>

        <v-tab-item value="tab-regularidadeFiscal">
          <v-form
            v-model="valid"
            ref="regularidadeFiscal"
            v-if="activeTab=='tab-regularidadeFiscal'"
          >
            <regularidadeFiscal
              :cadastroFornecedor="cadastroFornecedor"
              :model="model"
              :OldModel="OldModel"
              :isAlteracao="isAlteracaoComputed"
              :acaoTela="acaoTelaComputed"
              :enums="enums"
              :tipoDocumento="tipoDocumento"
            ></regularidadeFiscal>
          </v-form>
        </v-tab-item>

        <v-tab-item value="tab-qualificacao" v-if=" model.tipoCertificado !== 2">
          <v-form v-model="valid" ref="qualificacaoEconomica" v-if="activeTab=='tab-qualificacao'">
            <qualificacaoEconomica
              :modelQualificacao="modelQualificacao"
              :model="model"
              :OldModel="OldModel"
              :enums="enums"
              :pontuacaoIndices="pontuacaoIndices"
              :totaisContas="totaisContas"
            ></qualificacaoEconomica>
          </v-form>
        </v-tab-item>

        <v-tab-item value="tab-formulariosDeclaracoes">
          <v-form
            v-model="valid"
            ref="formulariosDeclaracoes"
            v-if="activeTab=='tab-formulariosDeclaracoes'"
          >
            <formulariosDeclaracoes
              :model="model"
              :OldModel="OldModel"
              :enums="enums"
              :fornecedorDeclaracaoVm="fornecedorDeclaracaoVm"
            ></formulariosDeclaracoes>
          </v-form>
        </v-tab-item>
      </v-tabs>
      <v-layout row d-inline class="p-t-30">
        <v-flex xs6 sm4 left p-t-30 v-if="$verificaPerfilHabilitador() || activeTab != 'tab-dados'">
          <v-btn large color="info" @click="voltar()">
            <v-icon dark left>arrow_back</v-icon>&nbsp;VOLTAR
          </v-btn>
        </v-flex>

        <v-flex v-if="this.activeTab == 'tab-formulariosDeclaracoes'" xs6 sm4 right p-t-30>
          <v-btn large color="info" @click="validaEnviar()">CONTINUAR</v-btn>
        </v-flex>

        <v-flex v-else xs6 sm4 right p-t-30>
          <v-btn large color="info" @click="continuar()">
            CONTINUAR
            <v-icon dark right>arrow_forward</v-icon>
          </v-btn>
        </v-flex>
      </v-layout> 
       <v-dialog v-model="dialog" max-width="320" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-2">Parabéns</v-card-title>
          <v-card-text>
            Envio realizado com sucesso.<br>
            Para prosseguimento da análise, aguardamos o envio do Termo de Declaração de Concordância e Veracidade,
            disponível em: acesso cadastro > solicitações > Termo de Concordância e Veracidade.<br><br>
            Número da solicitação:
            <strong>{{this.model.numSolicitacao}}</strong>.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="fecharDialogEnviar(model)">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>

    <dialogObservacao
      :config="modelDialogRejeitar"
      v-on:observacaoOk="fnAcaoModalRejeitar().rejeitar()"
      v-on:observacaoCancel="fnAcaoModalRejeitar().cancelar()"
    />
  </div>
</template>

<script>
import fornecedorMixin from "../../fornecedor/components/fornecedorMixin";
import dadosBasicos from "./dados-basicos";
import habilitacaoJuridica from "./habilitacao-juridica";
import familia from "./familia";
import qualificacaoTecnica from "./qualificacaoTecnica";
import regularidadeFiscal from "./regularidade-fiscal";
import qualificacaoEconomica from "./qualificacao-economica";
import formulariosDeclaracoes from "./formularios-declaracoes";
import Topo from "../../../components/Topo";
import Migalha from "../../../components/migalha";
import moment from 'moment';
export default {
  name: "fornecedor-form",
  mixins: [fornecedorMixin],
  components: { /*Componentes utilizados*/
    dadosBasicos,
    habilitacaoJuridica,
    familia,
    qualificacaoTecnica,
    regularidadeFiscal,
    qualificacaoEconomica,
    formulariosDeclaracoes,
    Migalha,
    Topo
  },
  data() {//Declaracao de variaveis
    return {
      listaDocsExigidos: [],
      listaDocsElegiveis: [],
      listaDocsNeutros: [],
      listaDocsNN: [],
      abas: {
        "tab-dados": 1,
        "tab-hab-juridica": 2,
        "tab-familia": 3,
        "tab-qualificacaoTecnica": 4,
        "tab-regularidadeFiscal": 5,
        "tab-qualificacao": 6,
        "tab-formulariosDeclaracoes": 7
      }
    };
  },
   created() /*Metodo de start do componente*/{    
    this.$store.commit("setAba", {
        abaAtiva: "tab-dados"
      });
      
  },

  computed: {
      isAlteracaoComputed() {
        // Validador sempre analisa solicitações (incluindo alterações)
        // Se model existe e tem ID, é uma solicitação enviada
        return this.model && this.model.idFornecSolicitacao && 
              (this.model.tipoSolicitacao === 2 || this.$route.params.alterar);
    },
    
    acaoTelaComputed() {
      // Para Validadores: sempre 'alterar' quando analisam
      return this.model && this.model.tipoSolicitacao === 2 ? 'alterar' : 'incluir';
    }
  },

  methods: {//Declaracao de todos os metodos

   listaExigidos() {
      // Lista de documentos exigiveis
      var guarda = [];

  
       this.listaDocsExigidos = this.listaDocsQualificacaoTecnica.lista.filter(
        item => {
          // #132793 - Cadastrar e Consultar Qualificacao Tecnica
          if (item.codDocumento === 109) return false;

          let documentoJaAnalisado = guarda.find(x => x.codDocumento === item.codDocumento);

          if (!documentoJaAnalisado && item.exigido === "S") {
            guarda.push(item);

            return true;
          } else {
            return false;
          }
        }
      );

      //this.mergeListaQualificacaoFornecedor("exigidos");
      
      this.listaElegiveis();
      this.listaNN();
      this.listaNeutros();
    },
    listaElegiveis() {
      //lista de documentos elegiveis
      var guarda = [];
      this.listaDocsElegiveis = this.listaDocsQualificacaoTecnica.lista.filter(
        item => {
          if (
            !guarda.find(x => x.codDocumento === item.codDocumento) &&
            !this.listaDocsExigidos.find(
              x => x.codDocumento === item.codDocumento
            ) &&
            item.elegivel === "S"
          ) {
            guarda.push(item);
            return true;
          } else {
            return false;
          }
        }
      );  
    },
    listaNeutros() {
    
        this.listaDocsNeutros = this.listaDocsQualificacaoTecnica.lista.filter(
          item => {
            if (item.codDocumento == 166 &&          
              item.elegivel === "N" && item.exigido === "N"
            ) {          
              return true;            
            } else {
              return false;
            }          
          }        
        );         
        },
    validaIfObrigatorioVistoria(validar,required) {
      //validar se é obrigatorio
      if (this.model.flagEstrangeiro === '0' ) {
        let contador = 0;
      if(validar){
          if (this.model.flagEstrangeiro === '0' ) {
                var listaNeutrosvalidados = this.model.familiaSolicitacao.filter(element => 
                element.familiaFornecSituacao == "2" && 
            ( element.codGrupo == "01" && element.numFamilia == "98" || element.codGrupo == "03" && element.numFamilia == "16"
            || element.codGrupo == "03" && element.numFamilia == "25" || element.codGrupo == "03" && element.numFamilia == "30"
            || element.codGrupo == "04" && element.numFamilia == "56"          
            ));               
                if(listaNeutrosvalidados.length > 0 )
                {
                
                  if(required) return true;
                  return this.validacao.campoObrigatorio;
                }
                else
                {
                  if(required) return false;
                  return [];
                }
            }
            else
                {
                  if(required) return false;
                  return [];
                }
        
            }
            else
                  {
                    if(required) return false;
                    return [];
                  }		
      }
    
    }, 
    listaNN() {
      //lista de documentos elegiveis
     
      var guarda = [];
      this.listaDocsNN = this.listaDocsQualificacaoTecnica.lista.filter(
        item => {
          if (
            !guarda.find(x => x.codDocumento === item.codDocumento) &&           
            item.elegivel === "N" && item.exigido === "N"
          ) {
            guarda.push(item);
            return true;
          } else {
            return false;
          }
        }
      );      
    },
    imprimir_crc($event){
      this.model.tipoCertificado = $event;
    },
    continuar(){      
      //método para avançar de aba
    
      switch (this.activeTab) {
        case "tab-dados":
          if (this.model.tipFornecedor === "F") {
            this.setAba("tab-familia");
          } else {
            this.setAba("tab-hab-juridica");
          }
          break;
        case "tab-hab-juridica":
          this.setAba("tab-familia");
          break;
        case "tab-familia":
          this.listaExigidos();
         
          if( this.listaDocsExigidos.length > 0 || this.listaDocsElegiveis.length >0 || this.listaDocsNN.length > 0)
          {
            this.setAba("tab-qualificacaoTecnica"); 
          }
          else
          {
              this.setAba("tab-regularidadeFiscal");
          }
          break;
        case "tab-qualificacaoTecnica":
        this.listaExigidos();
          this.setAba("tab-regularidadeFiscal");
          break;
        case "tab-regularidadeFiscal":
          if (this.model.tipoCertificado === 3 || this.model.tipoCertificado === 2)
            this.setAba("tab-formulariosDeclaracoes");
          else this.setAba("tab-qualificacao");
          break;
        case "tab-qualificacao":
          this.setAba("tab-formulariosDeclaracoes");
          break;
        default:
          this.cadastroFornecedor();
      }
       this.setAbaVoltar(this.activeTab);
    },

    /*override*/
    setAba(abaAtiva) {
      
      this.$store.commit("setCalcLimpa", {
         setCalcLimpa: 2
     });
     this.$store.commit("setAba", {
        abaAtiva: abaAtiva
      });
     
      //setar a aba escolhida    
      if (abaAtiva === this.activeTab)
        return;

      this.erros = { erro: false, msg: null, obj: [], abaErro: null };
      
      let abas = this.abas;

      if (abas[abaAtiva] < abas[this.activeTab]) {
        this.abaAtiva = abaAtiva;
        this.activeTab = abaAtiva;      
        return true;
      }

      Promise.all([this.cadastroFornecedor(true)]).then(valida => {    
        if (valida[0] && this.validaModel(this.activeTab, abaAtiva)) {
       
          switch (abaAtiva) {
            case "tab-dados":
              if (!this.validModelDadosBasicosHabilitador())
                return false;
              break;
            case "tab-hab-juridica":
              if (!this.validModelHabJuridicaHabilitador())
                return false;
              break;
            case "tab-familia":
              if (!this.validModelFamiliaHabilitador())
                return false;
              break;
            //TIRA A OBRIGATORIEDADE DE APROVAR FAMILIA PARA IR PARA ABA QUALIFICACAO TECNICA
            // mas mantém a obrigatoriedade de aprovar as abas anteriores a família
            case "tab-qualificacaoTecnica":
            
              if (!this.validModelFamiliaHabilitador())
                return false;
              break;
            case "tab-regularidadeFiscal":
              if (!this.validModelRegularidadeFiscalHabilitador() || !this.validModelqualificacaoTecnicaHabilitador())
                return false;
              break;
            case "tab-qualificacao":
              if (!this.validModelQualificacaoHabilitador())
                return false;
              break;
            case "tab-formulariosDeclaracoes":
              if (!this.validModelformulariosDeclaracoes())
                return false;
              break;
          }
          this.abaAtiva = abaAtiva;
          this.activeTab = abaAtiva;
      
         this.setAbaVoltar(this.activeTab);
        
        }
        return true;
      });
    },

    setAbaVoltar(abaNova){
      this.$store.commit("setAba", {
        abaAtiva: abaNova
      });
    },
    validModelDadosBasicosHabilitador() {
      //verifica se o habilitador avaliou os documentos de dados basicos
      let valido = true;

       if (this.model.tipFornecedor === "F"){
          this.listaDocFornecSolicitacao.forEach(element => {
            if (element.docSolicitacao.arquivoUploadSituacao == null && element.codDocumento === 140) {
              valido = false;
              this.setErro("Aprove ou Rejeite o anexo do Documento de Identificação.", "tab-dados");
            }
        });
      }
      return valido;
    },

    validModelHabJuridicaHabilitador() {
      //verifica se o habilitador avaliou os documentos de dados baiscos
      if (!this.validModelDadosBasicosHabilitador()) {
        return false;
      }
      return true;
    },

    validModelFamiliaHabilitador() {
      //verifica se o habilitador avaliou também a habilitação juridica
      let valido = true;
      if (this.model.tipFornecedor === "F") {
        if (!this.validModelDadosBasicosHabilitador()) {
          return false;
        }
      } else {
        if (!this.validModelHabJuridicaHabilitador()) {
          return false;
        } else {
            if (!this.validaDocsHabJuridica()) return false;
            
            if (!this.validaSociosDirigentes()) return false;

            if (!this.validaAnexosFamilia()) return false;
         }
      }
      return valido;
    },

    validaQualificacaoVistoria(){
      var VerificaVistoria = this.validaIfObrigatorioVistoria(true,true) 
     var listaNeutrosvalidados = this.model.familiaSolicitacao.filter(element => 
                element.familiaFornecSituacao == "2" && 
            ( element.codGrupo == "01" && element.numFamilia == "98" || element.codGrupo == "03" && element.numFamilia == "16"
            || element.codGrupo == "03" && element.numFamilia == "25" || element.codGrupo == "03" && element.numFamilia == "30"
            || element.codGrupo == "04" && element.numFamilia == "56"          
            ));

          if(VerificaVistoria){
            
            if(this.listaDocsNeutros.length == 0 && listaNeutrosvalidados.length == 0){             
         
              this.setErro(
                  "Aprove ou Rejeite todos os documentos de Qualificação Tecnica.",
                  "tab-qualificacaoTecnica"
                );  
                return false;
            }

            this.listaDocsNeutros.forEach(element => {
              if(!element.arquivoUploadSituacao && !!element.arquivoUpload){
        
                this.setErro(
                  "Aprove ou Rejeite todos os documentos de Qualificação Tecnica.",
                  "tab-qualificacaoTecnica"
                );  
                return false;
              }
            })

          }
          return true;
    },
    /* 
     * Método que avalia se todos os documentos de
     * habilitação jurídica foram aprovados ou rejeitados 
     */

    validaDocsHabJuridica(){
      var retorno = true;
      
      this.model.documentosSolicitacao.forEach(element => {
          if (!element.arquivoUploadSituacao && !!element.arquivoUpload) {
            this.setErro(
              "Aprove ou Rejeite todos os documentos de Habilitação Jurídica.",
              "tab-hab-juridica"
            );            
            retorno = false;
            return false;
          }

          if(element.arquivoUpload == null || (element.arquivoUpload != null && element.arquivoUpload === "Não Encontrado")){
          
            this.setErro("Anexo Inválido","tab-hab-juridica");
            this.hasErroDocHabilitacao = true;
            retorno = false;
            return false;
          }
        });

      return retorno;
    },

    validaAnexosFamilia() {
      return true;
    },

    /*
     * Método que analisa a aprovação/rejeição dos sócios e dirigentes,
     * e o preenchimento dos anexos dos sócios e dirigentes 
     */
    validaSociosDirigentes() {
      var retorno = true;
      
      this.model.fornecedoresHabilitacaoJuridica.forEach(element => {
        if (!element.habilitacaoJuridicaSituacao) {
          this.setErro(
            "Aprove ou Rejeite todos os Sócios ou Dirigentes.",
            "tab-hab-juridica"
          );

          retorno = false;
          
          return false;
        }

        if (!element.arquivoUpload || element.arquivoUpload === "Não Encontrado") {
          this.setErro(
            "Todos os anexos de Sócios ou Dirigentes devem ser preenchidos.",
            "tab-hab-juridica"
          );

          retorno = false;

          return false;
        }

        return true;
      });

      return retorno;
    },

    validModelqualificacaoTecnicaHabilitador() {
      // Verifica se o habilitador avaliou também a familia
      if (!this.validModelFamiliaHabilitador()) {
        return false;
      } else {
        let familiaSemAvaliacao = this.model.familiaSolicitacao.filter(
          x => x.familiaFornecSituacao == null
        );

        if (familiaSemAvaliacao.length){

          this.setErro("Aprove ou Rejeite todas as Famílias.", "tab-familia");
          
          return false;
        }
      }
      
      return true;
    },

      validModelRegularidadeFiscalHabilitador() {
        var retorno = true;

        if (!this.validaQualificacaoVistoria())
          return false;

        // Se qualificacaoTecnica for null ou undefined, retorna true (válido)
        if (!this.model.qualificacaoTecnica || !Array.isArray(this.model.qualificacaoTecnica))
          return true;

        for (let i = 0; i < this.model.qualificacaoTecnica.length; i++) {
          const x = this.model.qualificacaoTecnica[i];

          if (this.model.flagEstrangeiro === '0') {
            if (x.arquivoUpload == null || x.arquivoUpload === "Não Encontrado") {
              retorno = false;
              this.setErro(
                "Todos os anexos de Qualificações Técnicas devem ser preenchidos!",
                "tab-qualificacaoTecnica"
              );
              break;
            }
          }

          if (x.qualificacaoTecnicaSituacao == null) {
            const listDocumento = this.listaDocsQualificacaoTecnica.lista.filter(
              l => l.codDocumento === x.codDocumento
            );

            for (let j = 0; j < listDocumento.length; j++) {
              const doc = listDocumento[j];
              const f = this.model.familiaSolicitacao.find(
                f =>
                  f.codGrupo === doc.codGrupo &&
                  f.numFamilia === doc.numFamilia
              );
              if (f && retorno) {
                retorno = false;
                this.setErro(
                  "Aprove ou Rejeite todos os documentos de Qualificação Técnica.",
                  "tab-qualificacaoTecnica"
                );
                break;
              }
            }
          }

          if (!retorno) break;
        }

        if (!this.validModelqualificacaoTecnicaHabilitador())
          retorno = false;

        return retorno;
      },
    verificaObrigatoriedadeRegularidade(tipDocumento) {
      //verifica se o habilitador avaliou também a regularidade fiscal
      //OBRIGA APROVAR FAMILIA PARA IR PARA PROXIMA ABA
      if (!this.validModelqualificacaoTecnicaHabilitador()){
        return false;
      } else {
        var grupoServico = this.model.familiaSolicitacao.find(x => x.codGrupo <= 9);
        var grupoMaterial = this.model.familiaSolicitacao.find(x => x.codGrupo > 9);
        var chave = this.enums.tipoDocumento.find(x=> x.valor === tipDocumento).chave;

        if (
          ((!this.grupoServico || this.model.tipoCertificado === 3) && chave === 'ContribuinteMunicipalServicos') ||
          (!grupoMaterial && chave === "ContribuinteEstadualMaterial") ||
          (!grupoServico && chave === "ContribuinteMunicipalServicos") ||
          (this.model.codUf === "BA" && chave === "EstadualBA" && this.model.flagEstrangeiro !== '1') ||
          (this.model.codUf === "DF" && (chave === "Municipal" || chave === "ContribuinteMunicipalServicos") && this.model.flagEstrangeiro !== '1') ||
          (this.model.tipFornecedor === "J" && chave === "CNPJ") ||
          (this.model.tipFornecedor === "F" && chave === "CNPJ")
        ) {
          return false;
        }

        return true;
      }
    },

    validModelQualificacaoHabilitador() {
      
      if (!this.validModelRegularidadeFiscalHabilitador()
      || !this.validModelqualificacaoTecnicaHabilitador()) { //OBRIGA APROVAR FAMILIA PARA IR PARA PROXIMA ABA
        return false;
      } else {
    
         let regularidadeSemAnexo = this.model.regularidadeFiscTrab.filter(
          x => ((x.arquivoUpload == null || x.arquivoUpload === "Não Encontrado")
              && this.verificaObrigatoriedadeRegularidade(x.tipDocumento))
        );
     
        if (regularidadeSemAnexo.length) {
          this.setErro(
            "Todos os anexos de Regularidade Fiscal e Trabalhista devem ser preenchidos.",
            "tab-regularidadeFiscal"
          );
          return false;
        }       
        let regularidadeSemAvaliacao = this.model.regularidadeFiscTrab.filter(
          x => x.regularidadeFiscTrabSituacao == null && this.verificaObrigatoriedadeRegularidade(x.tipDocumento)
        );
  
        let regularidadeSemAvaliacaoDocumentoAnexado = this.model.regularidadeFiscTrab.filter(
          x => ((x.regularidadeFiscTrabSituacao == null) && (x.arquivoUpload != null))
         );
              
        if (regularidadeSemAvaliacao.length || regularidadeSemAvaliacaoDocumentoAnexado.length) {
          this.setErro(
            "Aprove ou Rejeite todos os documentos de Regularidade Fiscal e Trabalhista.",
            "tab-regularidadeFiscal"
          );
          return false;
        }
      }
      return true;
    },

    validModelformulariosDeclaracoes() {
      //verifica se o habilitador avaliou também a qualificacao economica
      if (!this.validModelQualificacaoHabilitador()
      || !this.validModelqualificacaoTecnicaHabilitador()) { //OBRIGA APROVAR FAMILIA PARA IR PARA PROXIMA ABA
        return false;
      } else {
        if (this.model.tipoCertificado === 1 &&
           (this.model.concordataFalencia && this.model.concordataFalencia.arquivoUpload === "Não Encontrado" ||
           (this.model.balancoFinanceiro && this.model.balancoFinanceiro.arquivoUpload === "Não Encontrado"))
           )
        {

           this.setErro(
            "Todos os anexos de Qualificação Econômico-Financeira devem ser preenchidos.",
            "tab-qualificacao");
            return false;
        }
        /*if (
          this.model.tipoCertificado === 1 &&
          ((this.model.concordataFalencia &&
            !this.model.concordataFalencia.arquivoUploadSituacao &&
            this.model.concordataFalencia.arquivoUpload) ||
            (this.model.balancoFinanceiro &&
              !this.model.balancoFinanceiro.arquivoUploadSituacao &&
              this.model.balancoFinanceiro.arquivoUpload))
        ) { */    

          if (
              this.model.tipoCertificado === 1 &&
              (
                (this.model.concordataFalencia &&
                !this.model.concordataFalencia.arquivoUploadSituacao &&
                this.model.concordataFalencia.arquivoUpload) ||
                (this.model.balancoFinanceiro &&
                !this.model.balancoFinanceiro.arquivoUploadSituacao ||
                !this.model.balancoFinanceiro.arquivoUploadSituacao02 &&
                this.model.balancoFinanceiro.arquivoUpload && this.model.balancoFinanceiro.arquivoUpload02)
              )
          ) {
          this.activeTab = "tab-hab-juridica";

          this.setErro(
            "Aprove ou Rejeite todos os documentos de Qualificação Econômico-Financeira..",
            "tab-qualificacao"
          );
        

          return false;
        }
      }
      return true;
    },
    validaEnviar() {
      if(this.validModelformulariosDeclaracoes()){
     
        //verifica se o habilitador avaliou também os formularios e declaracoes
        Promise.all([this.cadastroFornecedor(true)]).then(valida => {
          if (valida[0]) {            
            let verificaNaoEncontrado = this.fornecedorDeclaracaoVm.lista.find(
              x =>
                x.uploadDeclaracao.arquivoUpload === "Não Encontrado" &&
                x.uploadDeclaracao.exibe
            );

            let verificaNotAnalise = this.fornecedorDeclaracaoVm.lista.find(
              x =>
                x.uploadDeclaracao.arquivoUpload != null &&
                x.uploadDeclaracao.uploadDeclaracaoSituacao == null &&
                x.uploadDeclaracao.exibe
            );

            if (!verificaNotAnalise && !verificaNaoEncontrado) {
              this.abrirResumoHabilitador();
            }
            if (verificaNaoEncontrado) {
              this.setErro(
                "Todos os anexos de Formulários e Declarações obrigatórios devem ser preenchidos.",
                "tab-formulariosDeclaracoes"
              );
            }
            if (verificaNotAnalise) {
              this.setErro(
                "Aprove ou Rejeite todos os documentos de Formulários e Declarações.",
                "tab-formulariosDeclaracoes"
              );
            }
          }
        });
      }
    }
  }
};
</script>

<style>
.abaAtiva a {
  color: #349fbe !important;
}

html {
  scroll-behavior: smooth;
}
</style>
